import { render, staticRenderFns } from "./coffee-sampler-list-home.vue?vue&type=template&id=9621287a&"
import script from "./coffee-sampler-list-home.vue?vue&type=script&lang=js&"
export * from "./coffee-sampler-list-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports